import { useSearchParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

export const useRegistrarFilter = (registrars = []) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const selectedRegistrarId = useMemo(() => {
        const paramId = searchParams.get('registrar');
        const validId = registrars.find((r) => r.id === paramId)?.id;
        return validId || registrars[0]?.id || '';
    }, [searchParams, registrars]);

    const setRegistrarFilter = useCallback(
        (registrarId) => {
            const newParams = new URLSearchParams(searchParams);
            if (registrarId && registrarId !== registrars[0]?.id) {
                newParams.set('registrar', registrarId);
            } else {
                newParams.delete('registrar');
            }
            setSearchParams(newParams);
        },
        [searchParams, setSearchParams, registrars],
    );

    return { selectedRegistrarId, setRegistrarFilter };
};
